import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../redux/selectors/resources';

export const AboutApplicationScreen = () => {
  const content = useSelector(contentSelector());
  return View({
    content,
  });
};
